module.exports = __webpack_public_path__ + "img/13-1_02.c917b3c8.jpg";